const getters = {
  authToken: state => state.user.authToken,
  functions: state => state.user.functions,
  routers: state => state.user.routers,
  addRouters: state => state.user.addRouters,
  name: state => state.user.name,
  sidebar: state => state.app.sidebar,
  locations: state => state.location.locations,
  account: state => state.user.account,
  selectedMenu: state => state.user.selectedMenu,
  conUrl: state => state.app.conUrl
}

export default getters


// WEBPACK FOOTER //
// ./src/store/getters.js